import axios from "axios";
import store from "../store";

import { domain } from "../utils/Constants";

const http = new axios.create({
    baseURL: domain
});

http.interceptors.response.use(undefined, function(err) {
    return new Promise(function(resolve, reject) {
        if (
            err.response.status === 401 &&
            err.config &&
            !err.config.__isRetryRequest
        ) {
            // if you ever get an unauthorized, logout the user
            // this.$router
            //     .push("/login")
            window.localStorage.removeItem("vuex");
            window.sessionStorage.removeItem('vuex')
            setTimeout(function() {
                window.location.reload();
            }, 300);

            // you can also redirect to /login if needed !
        }
        throw err;
    });
});

const httpMethod = {
    get(url, options = {}) {
        if (!store.state.Auth.accessToken) {
            return Promise.reject("No access token.");
        }

        return http
            .get(url, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${store.state.Auth.accessToken}`
                }
            })
            .then(res => res.data)
            .catch(err => Promise.reject(err.response.data))
    },
    post(url, data = null, options = {}) {
        if (!store.state.Auth.accessToken) {
            return Promise.reject("No access token.");
        }

        return http
            .post(url, data, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${store.state.Auth.accessToken}`
                }
            })
            .then(res => res.data)
            .catch(err => Promise.reject(err.response.data))
    },
    put(url, data = null, options = {}) {
        if (!store.state.Auth.accessToken) {
            return Promise.reject("No access token.");
        }

        return http
            .put(url, data, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${store.state.Auth.accessToken}`
                }
            })
            .then(res => res.data)
            .catch(err => Promise.reject(err.response.data))
    },
    delete(url, options = {}) {
        if (!store.state.Auth.accessToken) {
            return Promise.reject("No access token.");
        }

        return http
            .delete(url, {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: `Bearer ${store.state.Auth.accessToken}`
                }
            })
            .then(res => res.data)
            .catch(err => Promise.reject(err.response.data))
    }
};

export default httpMethod;
